<div class="min-[991px]:w-[80%] w-full">
    <!-- Title -->
    <h1 class="mb-[14px] min-[991px]:mb-[64px] text-black text-[16px] min-[991px]:text-[32px] font-[700]">
        {{ 'Tell_Us_About_Your_Business' | translate }}
    </h1>

    <form [formGroup]="form" (ngSubmit)="submit()">
        <!-- Business Name Field -->
        <div class="min-[991px]:mb-[2px] flex flex-col">
            <mat-label class="mb-[2px] min-[991px]:mb-[8px] text-[#000] text-[12px] min-[991px]:text-[16px] font-[400] min-[991px]:font-[500]">
                {{ 'business_name' | translate }}
                <span class="text-[#6059a2]">*</span>
            </mat-label>
            <mat-form-field appearance="outline">
                <input
                    matInput
                    [placeholder]="'Enter_Your_Business_Name' | translate"
                    formControlName="BusinessName"
                />
                <mat-error>
                    <app-error-form
                        [name]="'business_name' | translate"
                        [control]="form.controls['BusinessName']"
                        [maxLength]="30"
                        [minLength]="4"
                    ></app-error-form>
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Country & City Field -->
        <div class="min-[991px]:mb-[2px] flex items-center justify-between">
            <!-- Country Part -->
            <div class="w-[48.5%] min-[991px]:w-[47%] min-w-0 flex flex-col">
                <mat-label *ngIf="!countriesLoading" class="mb-[2px] min-[991px]:mb-[8px] text-[#000] text-[12px] min-[991px]:text-[16px] font-[400] min-[991px]:font-[500]">
                    {{ 'Country' | translate }}
                    <span class="text-[#6059a2]">*</span>
                </mat-label>
                <ng-container *ngIf="!countriesLoading; else countrySkeleton">
                    <mat-form-field appearance="outline">
                        <mat-select
                            disableRipple
                            formControlName="CountryId"
                            (selectionChange)="onChangeCountry($event)"
                            [placeholder]="'Country' | translate">
                            <mat-option *ngFor="let country of countries" [value]="country.Id">
                            {{ dir == 'rtl' ? country.NameAr : country.NameEn }}
                            </mat-option>
                        </mat-select>
                        <mat-error>
                            <app-error-form
                                [name]="'Country' | translate"
                                [control]="form.controls['CountryId']"
                            ></app-error-form>
                        </mat-error>
                    </mat-form-field>
                </ng-container>
                <ng-template #countrySkeleton>
                    <div class="animate-pulse flex flex-col gap-[6px]">
                        <div class="h-[10px] w-[80px] bg-[#e0e0e0] rounded"></div>
                        <div class="h-[42px] min-[991px]:h-[56px] w-full rounded-[12px] bg-[#f5f5f5]"></div>
                    </div>
                </ng-template>
            </div>

            <!-- City Part -->
            <div class="w-[48.5%] min-[991px]:w-[47%] min-w-0 min-w-0 flex flex-col">
                <mat-label *ngIf="!citiesLoading" class="mb-[2px] min-[991px]:mb-[8px] text-[#000] text-[12px] min-[991px]:text-[16px] font-[400] min-[991px]:font-[500]">
                    {{ 'City' | translate }}
                    <span class="text-[#6059a2]">*</span>
                </mat-label>
                <ng-container *ngIf="!citiesLoading; else citySkeleton">
                    <mat-form-field appearance="outline">
                        <mat-select
                            disableRipple
                            formControlName="CityId"
                            [placeholder]="'City' | translate">
                            <mat-option *ngFor="let city of cities" [value]="city.Id">
                            {{ dir == 'rtl' ? city.NameAr : city.NameEn }}
                            </mat-option>
                        </mat-select>
                        <mat-error>
                            <app-error-form
                                [name]="'City' | translate"
                                [control]="form.controls['CityId']"
                            ></app-error-form>
                        </mat-error>
                    </mat-form-field>
                </ng-container>
                <ng-template #citySkeleton>
                    <div class="animate-pulse flex flex-col gap-[6px]">
                        <div class="h-[10px] w-[80px] bg-[#e0e0e0] rounded"></div>
                        <div class="h-[42px] min-[991px]:h-[56px] w-full rounded-[12px] bg-[#f5f5f5]"></div>
                    </div>
                </ng-template>
            </div>
        </div>

        <!-- Business Types -->
        <div class="mb-[12px] min-[991px]:mb-[33px]">
            <mat-label *ngIf="!businessTypesLoading" class="text-[#000] text-[12px] min-[991px]:text-[16px] font-[400] min-[991px]:font-[500]">
                {{ 'BusinessType' | translate }}
                <span class="text-[#6059a2]">*</span>
            </mat-label>

            <div *ngIf="!businessTypesLoading" 
                class="mt-[10px] min-[991px]:mt-[8px] gap-y-[24px] gap-x-[16px]" 
                fxLayout="row wrap" 
                fxLayoutAlign="start start">
                <div
                    *ngFor="let type of businessType"
                    class="flex items-center gap-[12px] cursor-pointer"
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxFlex.gt-sm="48"
                    fxFlex.lt-md="100"
                    [ngClass]="{
                        '!cursor-not-allowed !opacity-50': notAllowedBusinessTypes.includes(type?.BusinessType)
                    }">
                    <mat-checkbox
                        [checked]="type.active"
                        [disabled]="notAllowedBusinessTypes.includes(type?.BusinessType)"
                        (change)="onSelectBusinessType(type)"
                        color="primary"
                    ></mat-checkbox>
                    <div
                        class="flex-1 min-w-0 flex items-center gap-[12px] h-[56px] px-[16px] py-[15px] box-border rounded-[12px] border border-[#c5d5dc] bg-white cursor-pointer transition-colors duration-200"
                        [ngClass]="{ 
                            '!border-[#635ca8]': type.active,
                            '!cursor-not-allowed': notAllowedBusinessTypes.includes(type?.BusinessType)
                        }"
                        (click)="onSelectBusinessType(type)">

                        <img
                            class="w-[40px] h-[40px] min-w-[40px] object-contain max-[575px]:w-[32px] max-[575px]:h-[32px] max-[575px]:min-w-[32px]"
                            [src]="type.ImagePath"
                            [alt]="dir == 'rtl' ? type.NameAr : type.NameEn"
                            [title]="dir == 'rtl' ? type.NameAr : type.NameEn"/>

                        <span class="text-[12px] min-[991px]:text-[16px] font-[400] text-black">
                            {{ dir == 'rtl' ? type.NameAr : type.NameEn }}
                        </span>
                    </div>
                </div>
            </div>

            <!-- Label Skeleton -->
            <div *ngIf="businessTypesLoading" class="animate-pulse flex flex-col gap-2">
                <div class="h-[12px] w-[120px] bg-gray-200 rounded"></div>
                <!-- List -->
                <div class="mt-[10px] min-[991px]:mt-[8px] flex flex-wrap gap-y-[24px] gap-x-[16px]">
                    <!-- item -->
                    <div *ngFor="let item of [1,2,3,4, 5, 6]" class="w-full min-[576px]:w-[48%] flex items-center gap-[12px]">
                        <!-- checkbox -->
                        <div class="w-[18px] h-[18px] bg-gray-200 rounded"></div>
                        <!-- card -->
                        <div class="flex-1 flex items-center gap-[12px] h-[56px] px-[16px] py-[15px] rounded-[12px] bg-gray-100">
                            <!-- image -->
                            <div class="w-[40px] h-[40px] min-w-[40px] bg-gray-200 rounded-full"></div>
                            <!-- text -->
                            <div class="flex flex-col gap-[6px] w-full">
                                <div class="h-[10px] w-[70%] bg-gray-200 rounded"></div>
                                <div class="h-[10px] w-[40%] bg-gray-200 rounded"></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- How did you know us -->
        <div class="min-[991px]:mb-[2px] felx flex-col">
            <mat-label class="text-[#000] text-[12px] min-[991px]:text-[16px] font-[400] min-[991px]:font-[500]">
                {{ 'HOW_DID_U_KNOW_US' | translate }}
                <span class="text-[#6059a2]">*</span>
            </mat-label>

            <mat-form-field class="mt-[2px] min-[991px]:mt-[8px]" appearance="outline">
                <mat-select
                    disableRipple
                    formControlName="KnowUsWayId"
                    [placeholder]="'HOW_DID_U_KNOW_US' | translate">
                
                    <mat-option *ngFor="let item of knowUsWays" [value]="item.Id">
                        <div class="flex items-center justify-start">
                            <img
                            [src]="item?.ImagePath ?? ''"
                            alt=""
                            class="w-[30px] h-[30px] rounded-full inline-block"
                            [title]="dir == 'rtl' ? item.NameAr : item.NameEn"/>
    
                            <span class="ms-1">{{ dir == 'rtl' ? item.NameAr : item.NameEn }}</span>
                        </div>
                    </mat-option>
                </mat-select>
                <mat-error>
                    <app-error-form
                        [name]="'HOW_DID_U_KNOW_US' | translate"
                        [control]="form.controls['KnowUsWayId']"
                    ></app-error-form>
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Are you currently using system -->
        <div class="mb-[16px] min-[991px]:mb-[32px] flex flex-col">
            <mat-label class="mb-[8px] min-[991px]:mb-[16px] text-[#000] text-[12px] min-[991px]:text-[16px] font-[400] min-[991px]:font-[500]">
                {{ 'ARE_U_CURRENTLY_USING_SYSTEM' | translate }}
            </mat-label>
            <mat-radio-group
                class="max-[991px]:flex max-[991px]:flex-col max-[991px]:items-start"
                formControlName="IsCurrentlyUsingAnyOtherSystem">
                <mat-radio-button [value]="true" color="primary">
                    {{ "Yes" | translate }}
                </mat-radio-button>
                <mat-radio-button class="mlr-30" [value]="false" color="primary">
                    {{ "No" | translate }}
                </mat-radio-button>
            </mat-radio-group>
        </div>

        <!-- Submit Button -->
        <div class="mb-[16px] min-[991px]:mb-[32px]">
            <button
                color="primary"
                type="submit"
                class="basic-details-submit-btn"
                [disabled]="!canSubmit || loading">
                {{ "Next" | translate }}
                <span class="btn-spinner-icon" *ngIf="loading"></span>
            </button>
        </div>
    </form>
</div>

